import {Message, Select} from '~/components'
import {DatePickerField, Input} from '@eitje/web_components'
import {Organisation} from '@eitje/api'
import {useFieldValue} from '@eitje/form'

const STATUS_ITEMS = [
	{id: 'active', t: 'common.status.active'},
	{id: 'eitje', t: 'common.status.eitje'},
]
const STRATEGY_ITEMS = [
	{id: 'new', t: 'modals.create_environment.strategy.new'},
	{id: 'attach', t: 'modals.create_environment.strategy.attach'},
]

export const FormFields = () => {
	const strategy = useFieldValue('strategy')
	const organisations = Organisation.useAll()
	return (
		<>
			<Message t="modals.create_environment.message" />
			<Input field="naam" required />
			<Input field="email" required />
			<Select field="status" items={STATUS_ITEMS} required />
			<Select field="strategy" items={STRATEGY_ITEMS} required />
			{strategy === 'new' && (
				<>
					<Input field="organisation_name" required />
					<DatePickerField field="first_billing_date" infoIconMessage required />
				</>
			)}
			{strategy === 'attach' && <Select field="organisation_id" label="organisation" items={organisations} required />}
		</>
	)
}
